export default {
    namespaced: true,
    state: {
        show: true,
    },
    mutations: {
        Show(state) {
            state.show = false;
        },
        Hide(state) {
            state.show = true;
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/curtain.js